import { Map as ImmutableMap, List as ImmutableList, fromJS } from 'immutable';
import http from 'hub-http/clients/apiClient';
import Raven from 'raven-js';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import I18n from 'I18n';
import { SupplementalObjects } from '../../../../types';

type Snippet = {
  contentId: number;
  name: string;
  contentType: 'SNIPPET';
  userId: number;
  shortcut?: string;
  description?: string;
};

export const defaultApiWrapper = (apiClient: typeof http) => ({
  fetchRenderedContent({
    id,
    contactEmail,
    contactVid,
    objectType,
    subjectId,
    supplementalObjects,
  }: {
    id: number;
    contactEmail?: string;
    contactVid?: string | number;
    objectType?: string;
    subjectId?: string;
    supplementalObjects?: SupplementalObjects;
  }) {
    const subjectAsSupplementalObject =
      objectType &&
      subjectId &&
      subjectId !== 'null' &&
      subjectId !== 'undefined'
        ? { [objectType]: subjectId }
        : {};
    return apiClient
      .post<{ body: string; htmlBody: string; missingProperties: string[] }>(
        'snippets/v1/render',
        {
          data: {
            snippetId: id,
            toEmail: contactEmail,
            contactId: contactVid,
            supplementalObjects: {
              ...supplementalObjects,
              ...subjectAsSupplementalObject,
            },
          },
        }
      )
      .catch((error: any) => {
        if (error.responseJSON?.category === 'UNAUTHORIZED') {
          FloatingAlertStore.addAlert({
            id: 'snippet-error',
            titleText: I18n.text(
              'draftPlugins.snippetsPlugin.permissionsError.title'
            ),
            message: I18n.text(
              'draftPlugins.snippetsPlugin.permissionsError.message'
            ),
            type: 'danger',
          });
        }

        Raven.captureException(error);
      });
  },
  // @ts-ignore ts-migrate FIXME
  fetchUnrenderedContent({ id }) {
    return apiClient.get(`snippets/v1/snippets/${id}`);
  },
  // @ts-ignore ts-migrate FIXME
  searchSnippets({ count, offset, query }) {
    return apiClient
      .post('salescontentsearch/v2/search', {
        data: {
          contentTypesToHydrate: ['SNIPPET'],
          filters: [
            {
              field: 'content_type',
              values: ['SNIPPET'],
            },
          ],
          ...(query ? {} : { sorts: [{ field: 'name', order: 'ASC' }] }),
          limit: count,
          offset,
          query,
        },
      })
      .then((response) => fromJS(response))
      .catch((error: any) => {
        Raven.captureException(error);
      });
  },
});

export const fetchAllSnippets = () =>
  http.get<Snippet[]>('snippets/v1/snippets').then((response) =>
    ImmutableMap({
      hasMore: false,
      offset: 0,
      count: response.length,
      total: response.length,
      results: ImmutableList(response).map((snippet) => fromJS(snippet)),
    })
  );

export const searchSnippets = ({
  count,
  offset,
  query,
}: {
  count?: number;
  offset?: number;
  query?: string;
}) =>
  http
    .post<{
      results: Snippet[];
      hasMore: boolean;
      offset: number;
      total: number;
    }>('salescontentsearch/v2/search', {
      data: {
        contentTypesToHydrate: ['SNIPPET'],
        filters: [
          {
            field: 'content_type',
            values: ['SNIPPET'],
          },
        ],
        ...(query ? {} : { sorts: [{ field: 'name', order: 'ASC' }] }),
        limit: count,
        offset,
        query,
      },
    })
    .then((response) => fromJS(response));
